import React, { useState } from 'react';
import { Box, Button, Grid, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { MTable } from '../../../../../Components';
import { HtmlView } from '../../../../../Components/Html/Html.View';
import { RichTextEditor } from '../../../../../Components/RichTextEditor/RichTextEditor';
import { OnboardingDraftSelect, hasText, lawRows, noteKey, useOnboardingDraft } from './OnboardingDraft';
import { useStyles } from './Onboarding.styles';

export const OnboardingLawNotes = () => {
  const { draft, update } = useOnboardingDraft();
  const { formatMessage: t } = useIntl();
  const classes = useStyles();
  const [formOpen, setFormOpen] = useState(false);
  const selectedLaws = draft.selectedLaws.map(law => ({ id: law.id, name: `${law.number} – ${law.name}` }));
  const savedNotes = lawRows(draft).flatMap(law => {
    const note = draft.notes[noteKey(law.id, law.companyUnitId)] || draft.notes[String(law.id)] || '';
    return hasText(note) ? [{ id: noteKey(law.id, law.companyUnitId), lawId: law.id, unitId: law.companyUnitId, law: `${law.number} – ${law.name}`, unit: law.companyUnitName, note }] : [];
  });
  const addNote = () => update(current => {
    const notes = { ...current.notes };
    const noteUnitIds = { ...current.noteUnitIds };
    (current.noteLawIds || []).forEach(lawId => {
      noteUnitIds[lawId] = Array.from(new Set([...(noteUnitIds[lawId] || []), ...(current.noteCompanyUnitIds || [])]));
      (current.noteCompanyUnitIds || []).forEach(unitId => { notes[noteKey(lawId, unitId)] = current.noteText || ''; });
    });
    return { ...current, notes, noteUnitIds, noteLawIds: [], noteCompanyUnitIds: [], noteText: '' };
  });

  return <>
    {!formOpen && <Box className={classes.listActions}>
      <Button color="primary" variant="outlined" onClick={() => setFormOpen(true)}>{t({ id: 'onboarding.add-note' })}</Button>
    </Box>}
    {formOpen && <Grid container spacing={2}>
    <Grid item xs={12} sm={6}><OnboardingDraftSelect name="note-legislation" label={t({ id: 'onboarding.select-law-notes' })} ids={draft.noteLawIds || []} options={selectedLaws} onChange={noteLawIds => update(current => ({ ...current, noteLawIds }))} /></Grid>
    <Grid item xs={12} sm={6}><OnboardingDraftSelect name="note-company-units" label={t({ id: 'form.selectCompanyUnits' })} ids={draft.noteCompanyUnitIds || []} options={draft.units} onChange={noteCompanyUnitIds => update(current => ({ ...current, noteCompanyUnitIds }))} /></Grid>
    <Grid item xs={12}><Typography variant="subtitle2">{t({ id: 'law-portal.overview-notes.form.note.label' })}</Typography><RichTextEditor value={draft.noteText || ''} onChange={noteText => update(current => ({ ...current, noteText }))} overrideConfig={{ height: 140 }} /></Grid>
    <Grid item xs={12} className={classes.formActions}><Button color="primary" variant="outlined" disabled={!(draft.noteLawIds || []).length || !(draft.noteCompanyUnitIds || []).length || !hasText(draft.noteText || '')} onClick={() => { addNote(); setFormOpen(false); }}>{t({ id: 'form.add' })}</Button></Grid>
    </Grid>}
    <MTable data={savedNotes} columns={[
      { title: t({ id: 'law-portal.manage.law-list.table.law' }), field: 'law' },
      { title: t({ id: 'law-portal.overview-notes.form.company-units.label' }), field: 'unit' },
      { title: t({ id: 'law-portal.overview-notes.form.note.label' }), field: 'note', render: row => <HtmlView value={row.note} /> },
    ]} actions={[row => ({ icon: 'delete', tooltip: t({ id: 'component.mtable.deleteTooltip' }), onClick: () => update(current => {
      const noteUnitIds = { ...current.noteUnitIds, [row.lawId]: (current.noteUnitIds[row.lawId] || []).filter(id => id !== row.unitId) };
      const notes = { ...current.notes };
      delete notes[noteKey(row.lawId, row.unitId)];
      return { ...current, noteUnitIds, notes };
    }) })]} />
  </>;
};
